import { render, staticRenderFns } from "./Placement.vue?vue&type=template&id=591343e9&scoped=true&lang=html&"
import script from "./Placement.vue?vue&type=script&lang=js&"
export * from "./Placement.vue?vue&type=script&lang=js&"
import style0 from "./Placement.vue?vue&type=style&index=0&id=591343e9&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591343e9",
  null
  
)

export default component.exports